var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-flex uk-flex-row news-page"},[_c('div',{staticClass:"news-block"},[_c('NewsRibbon',{attrs:{"items":_vm.newsItems}})],1),_c('div',{staticClass:"ads-block"},[_c('Ads')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }